import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SubmitAdmissionsFormMutation = graphql.persisted(
  "SubmitAdmissionsForm",
  graphql(`
    mutation SubmitAdmissionsForm($token: String!, $formData: JSON!) {
      submitAdmissionsForm(input: { token: $token, formData: $formData }) {
        familyEnrollment { id }
        userErrors { message path }
      }
    }
  `)
);

export { SubmitAdmissionsFormMutation };

export function useSubmitAdmissionsForm() {
  return useMutation(SubmitAdmissionsFormMutation);
}
